import Icon from '../components/Icon.vue'

Icon.register({
  'plane-departure': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h608zM80.5 341.3l-76.2-83c-7.6-9-4.9-22.8 5.6-28.1l40.1-20.4c2.4-1.2 5.2-1.9 8.1-1.9 2.9 0 5.6 0.7 8 1.9l72.3 36.5 103.2-52.4-156.2-98.1c-8.1-8.9-5.5-23.1 5.2-28.5l65.8-33.4c2.4-1.2 5.2-1.9 8.1-1.9 3.7 0 7.1 1.1 9.9 3l218.7 82.1 98.5-50c26.7-13.6 56.4-21.4 86.3-19.5 33.5 2.2 51 12.9 58.3 27.5 7.2 14.6 5.2 35.2-13.1 63.6-16.3 25.4-40.3 44.7-67 58.3l-291 147.6c-8.9 4.5-19 7.1-29.6 7.1l-130.5 0.2c-9.2 0-18-3.9-24.3-10.7z'
      }
    ]
  }
})
